import type React from 'react';
import { Chip } from '@heroui/react';
import { getNodeTestIdProp } from '@/utils';

/** A product state the name cell marks under the name. */
type ProductRowState = 'archived' | 'draft';

/** Each chip's test-id prefix, literal so a search finds it. */
const TEST_ID_PREFIX = {
    archived: 'product-row-archived',
    draft: 'product-row-draft',
} as const satisfies Record<ProductRowState, string>;

type ProductRowStateChipProps = {
    state: ProductRowState;
    productId: string;
    /** The chip's text ("Archived", "Draft"), localized by the table. */
    label: string;
};

/**
 * The small warning chip under a product's name for an archived or draft
 * product. It shrinks with its column and truncates its label, so the
 * archived and draft chips share the name cell's one line.
 */
export const ProductRowStateChip: React.FC<ProductRowStateChipProps> = ({
    state,
    productId,
    label,
}) => (
    <Chip
        className="min-w-0"
        color="warning"
        size="sm"
        variant="soft"
        {...getNodeTestIdProp(`${TEST_ID_PREFIX[state]}-${productId}`)}
    >
        <Chip.Label className="truncate">{label}</Chip.Label>
    </Chip>
);
